import {isDevToolsEnabled, env} from "@bounce/shared";
import {FeatureFlags, FeatureFlagValue} from "@bounce/shared/consumer/helpers";

const STORAGE_KEY = `${env}_feature_flags`;

export type FeatureFlagOverrides = Record<string, FeatureFlagValue>;

export const getStoredOverrides = (): FeatureFlagOverrides => {
  if (!isDevToolsEnabled()) return {};
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

export const setStoredOverrides = (overrides: FeatureFlagOverrides) => {
  if (!isDevToolsEnabled()) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
  } catch {}
};

export const setOverride = (key: string, value: FeatureFlagValue) => {
  const overrides = getStoredOverrides();
  overrides[key] = value;
  setStoredOverrides(overrides);
};

export const clearOverride = (key: string) => {
  const overrides = getStoredOverrides();
  delete overrides[key];
  setStoredOverrides(overrides);
};

export const clearAllOverrides = () => {
  if (!isDevToolsEnabled()) return;
  sessionStorage.removeItem(STORAGE_KEY);
};

export const applyOverrides = (backendFlags: FeatureFlags | undefined) => {
  if (!backendFlags || !isDevToolsEnabled()) return backendFlags;

  const overrides = getStoredOverrides();
  if (Object.keys(overrides).length === 0) return backendFlags;

  const mergedFlags = {...backendFlags};
  for (const [key, value] of Object.entries(overrides)) {
    // Inject the flag when the backend doesn't return it, so flags absent on an
    // environment (e.g. a flag that only exists on staging) can still be toggled via dev tools.
    mergedFlags[key] = mergedFlags[key]
      ? {...mergedFlags[key], value}
      : {value};
  }
  return mergedFlags;
};
